/*
  To get a single localised helpLink:

    import { Localisation } from '@workivate/tho-web-shared';

    const localisedHelpLink = Localisation.getHelplink({
      weblink: Localisation.helpLinks.getting_started,
      locale: 'fr_CA',
    });

  -> https://help.lifeworks.com/hc/fr-ca/articles/208461636

  *** The default locale is 'en_GB' ***

  To get all localised helpLinks:
  
      import { Localisation } from '@workivate/tho-web-shared';
  
      const localisedHelpLinks = Localisation.getAllHelpLinks('fr_CA');
*/

export { Localisation } from './localisation';
export * as LocalisationTypes from './helpLinks/helpLinks.types';
